module.exports = __webpack_public_path__ + "img/forest-setup.72c6dbbf.jpg";